import { useClickAway } from 'ahooks';
import { useCallback, useRef } from 'react';
import type { ITextReplaceResult } from '../types';
import { DataListItem } from './DataListItem';

interface DataListViewProps {
  dataList: ITextReplaceResult[];
  selectedItems: ITextReplaceResult[];
  setSelectedItems: (items: ITextReplaceResult[]) => void;
  editItem?: (
    item: ITextReplaceResult,
    data: {
      newOriginalText: string;
      newReplaceText: string;
    }
  ) => void;
  deleteItem?: (item: ITextReplaceResult) => void;
  editItemErrorKey?: string;
  setEditItemErrorKey?: (key: string) => void;
  setGenerateMode?: (isGenerateMode: boolean) => void;
  editItemKey: string;
  setEditItemKey: (key: string) => void;
  checkIfTheReplaceTextRuleExists: (oldValue: string) => boolean;
}

export const DataListView = ({
  dataList,
  setSelectedItems,
  selectedItems,
  deleteItem,
  editItem,
  editItemErrorKey,
  setEditItemErrorKey,
  editItemKey,
  setEditItemKey,
  checkIfTheReplaceTextRuleExists,
}: DataListViewProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleCheck = (item: ITextReplaceResult, isChecked: boolean) => {
    if (isChecked) {
      setSelectedItems([...selectedItems, item]);
    } else {
      setSelectedItems(
        selectedItems.filter((i) => i.original !== item.original)
      );
    }
  };

  useClickAway(() => {
    if (!editItemErrorKey) setEditItemKey('');
  }, ref);

  const checkOriginalReplaceChangeText = useCallback(
    (value: string) => {
      const valueWithoutSpaces = value.trim();
      const checkIfTextExistInDataList = (value: string) =>
        dataList.some((item) => item.original === value);
      return (
        checkIfTheReplaceTextRuleExists(valueWithoutSpaces) ||
        checkIfTextExistInDataList(valueWithoutSpaces)
      );
    },
    [dataList]
  );

  return (
    <div
      ref={ref}
      className="flex flex-col w-full overflow-y-auto gap-1.5 overflow-x-hidden  grow-0 max-h-[360px]"
    >
      {dataList.map((item) => (
        <DataListItem
          checkOriginalReplaceChangeText={checkOriginalReplaceChangeText}
          editKey={editItemKey}
          setEditKey={setEditItemKey}
          onDelete={() => deleteItem?.(item)}
          onEditText={(data) => editItem?.(item, data)}
          key={item.original}
          item={item}
          onCheck={(isChecked) => handleCheck(item, isChecked)}
          isChecked={!!selectedItems.find((i) => i.original === item.original)}
          editItemErrorKey={editItemErrorKey}
          setEditItemErrorKey={setEditItemErrorKey}
        />
      ))}
    </div>
  );
};
